import { IApplicationState } from '../../types/redux';
import { getIsPrevStepAvailable } from '../../utils/newReview/steps';

export const selectIsPrevStepAvailable = (state: IApplicationState): boolean => {
  return getIsPrevStepAvailable(state.newReview.meta.step, state.newReview.meta.mode);
};
